import PropTypes from "prop-types";

export const accountInfo = PropTypes.shape({
  activeAccountName: PropTypes.string,
  realm: PropTypes.string,
  domain: PropTypes.string,
});
